import { useState, useEffect } from 'react';
import { ApiClient } from '../services/apiClient';

export interface Operador {
  id: number;
  codigo: string;
  descripcion: string;
  nombre_completo?: string;
  rut?: string;
  telefono?: string;
  email?: string;
  estado: string;
  created_at: string;
  updated_at: string;
}

export interface UseOperadoresReturn {
  operadores: Operador[];
  cargandoOperadores: boolean;
  errorOperadores: string | null;
}

/**
 * Hook para cargar lista de operadores para formularios
 */
export const useOperadores = (): UseOperadoresReturn => {
  const [operadores, setOperadores] = useState<Operador[]>([]);
  const [cargandoOperadores, setCargandoOperadores] = useState(false);
  const [errorOperadores, setErrorOperadores] = useState<string | null>(null);

  useEffect(() => {
    const cargarOperadores = async () => {
      setCargandoOperadores(true);
      setErrorOperadores(null);
      
      try {
        // Usar el nuevo ApiClient sin código de fallback
        const operadoresData = await ApiClient.getList<Operador>('/operadores/lista');
        setOperadores(operadoresData);
      } catch (error: any) {
        console.error('❌ Error al cargar operadores:', error);
        setErrorOperadores(error.message || 'Error al cargar operadores');
        setOperadores([]);
      } finally {
        setCargandoOperadores(false);
      }
    };

    cargarOperadores();
  }, []);

  return {
    operadores,
    cargandoOperadores,
    errorOperadores
  };
};

export default useOperadores;
